// cleanQuery cleans a query string by reducing multiple whitespaces to a
// single one and trimming leading and trailing whitespace, to not cache
// similar queries multiple times.
export function cleanQuery(value?: string) {
  return value?.replaceAll(/\s+/g, ' ').trim() || undefined
}
